import { Fragment } from 'react';
import { cardSrc, parseJoker1Cards } from './resultParsers';

// Unlimited Joker (joker1/joker120) result — card string 6 codes, A=0,2,4 /
// B=1,3,5 (joker card result me nahi aata). Reference: pehla divider
// d-none-mobile; dono containers "casino-result-cards" (reference re-measured).
export default function Joker1Result({ detail }) {
  const cards = parseJoker1Cards(detail?.card);

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content joker-result">
          <div className="casino-result-content-diveder d-none-mobile"></div>
          {' '}
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              <div className="d-inline-block">
                <h4>Player A</h4>
                {cards.playerA.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          {' '}
          <div className="casino-result-content-diveder"></div>
          {' '}
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              <div className="d-inline-block">
                <h4>Player B</h4>
                {cards.playerB.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
